// extracted by mini-css-extract-plugin
module.exports = {"businessTypeLink":"BusinessTypes_businessTypeLink__UK4Ku","businessTypeIcon":"BusinessTypes_businessTypeIcon__zkPku"};